import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import React from 'react';

import 'bootstrap/dist/css/bootstrap.min.css';
import {Routes, Route} from 'react-router-dom';
import Home from './components/Home';
import Contactus from './components/Contactus';
import Login from './components/Login'
import Registration from './components/Registration';

import './App.css';
import { About } from './components/About';
import Footer from './components/Footer';
import Slider from './components/Slider';
import HeaderImg from './Images/header.png';
import CertificateView from './components/CertificateView';
import VolCertView from './components/VolCertView';


import MemberProfile from './components/memberProfile';



 function App() {
  return (
     <div style={{ background:'#F8F8F8'}}>
      <Container style={{margin: 'auto',display: 'flex', background:'#F8F8F8'}} >
      <img className="block w-100 " style={{maxHeight:170}}src={HeaderImg} alt="Logo"/>
      </Container>
      <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark">
    <Container>
      <Navbar.Brand href="/">IoT Club VNR VJIET</Navbar.Brand>
      <Navbar.Toggle style={{marginRight:0}} aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse id="responsive-navbar-nav">
        <Nav className="me-auto">
          <Nav.Link href="/IoTSprint2k22">IoT Sprint 2k22</Nav.Link>
          <Nav className="me-auto">
          <Nav.Link href="https://instagram.com/iotclub_vnr?igshid=MWI4MTIyMDE=" target="_blank">Follow us in Instagram</Nav.Link>
         
        </Nav>
        </Nav>
        
      </Navbar.Collapse>
    </Container>
  </Navbar>
  
 
    <Routes>
     <Route path="/" element={<Slider/>} />
    
     <Route path="/contactus" element={<Contactus/>}/>
     <Route path="/register/" element={<Registration/>}/>
     <Route path="/about" element={<About/>}/>
     
     <Route path="/IoTSprint2k22/:id/:name/:cert" element={<CertificateView/>}/>
     <Route path="/member/:id" element={<MemberProfile/>}/>
     <Route path="/IoTSprint2k22/vol/:name/:cert" element={<VolCertView/>}/>
    </Routes>
    
      </div>
  );
}
export default App;
